module.exports = __webpack_public_path__ + "img/25.8.TSS.c452c6db.png";